import Vue from "vue";
import * as Sentry from "@sentry/browser";
import {Vue as VueIntegration} from "@sentry/integrations";
import {IS_PRODUCTION} from '@/constants/isProduction'

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    environment: IS_PRODUCTION ? 'production' : 'dev',
    dsn: "https://af8d4c3b337b453289c4d1838f8fca65@o484189.ingest.sentry.io/5537416",
    integrations: [
      new VueIntegration({
        Vue,
        attachProps: true
      }),
    ],
  });
}
